import AnalyticsContainer from '../../organisms/analytics';

export default function Analytics() {
  return <AnalyticsContainer />;
}
